import {
  BLOG_ENTRY_VARIANTS,
  BE_01 as BLOG_ENTRY_BE01,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

import { BE06_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/BE06/plasmic-props";

export const BLOG_ENTRY_PLASMIC_PROPS = {
  variant: {
    type: "choice",
    options: BLOG_ENTRY_VARIANTS,
    defaultValue: BLOG_ENTRY_BE01,
    description: "Select blog entry variant",
  },
  className: {
    type: "string",
    defaultValue: "",
  },
  ...BE06_PLASMIC_PROPS,
};
